module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('h2', {
    staticClass: "fmtitle1"
  }, [_vm._v("List of Maps and Plates")]), _vm._v(" "), _c('h3', {
    staticClass: "sec1a"
  }, [_vm._v("Maps")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The fortresses of northern France and the southern Netherlands, 1745")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The battle of Fontenoy, 11 May 1745")]), _vm._v(" "), _c('h3', {
    staticClass: "sec1a"
  }, [_vm._v("Plates")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Maria-Theresa, Empress of Austria, Queen of Hungary and Bohemia.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Maurice de Saxe, Marshal of France.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("William Augustus, Duke of Cumberland.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("King Louis XV of France.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Lieutenant General Sir John Ligonier.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("British infantry advancing, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("c")]), _vm._v(".1745. A still from the excellent Stanley Kubrick film "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Barry Lyndon")]), _vm._v(" (1975).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("French artillery in action, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("c")]), _vm._v(".1745.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A French contemporary map of the battle of Fontenoy. Although some details are indistinct, the three-sided column of Cumberland’s infantry can be seen breaking into the French position.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The siege of Tournai, 1745 (previously thought to represent the 1709 siege by Marlborough).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tournai, rebuilt by Vauban, besieged by Saxe, 1745.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74955de2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Maps.vue
// module id = 72
// module chunks = 0